import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import styled from 'styled-components'

import { Pagination } from '../../components/pagination'
import { NavBar } from '../../components/navbar'
import { Footer } from '../../components/footer'
import { InputContainer} from '../signup'
import { Button } from '../../components/button'

import { PopularNigerianaData } from '../../popularnigerianadata'
import { BoxContainer, TextContainer, ImageContainer } from "../../components/postCard"
import axios from 'axios'

// import { useDispatch, useSelector } from 'react-redux'
// import { getRecentInternal } from '../../pages/features/public/publicSlice'

const SingleCategory = () => {

    // const dispatch = useDispatch()
    
    // const { publicResources, publicStatus} = useSelector(state => state.publicResources);

    // useEffect(() => {

    //     dispatch(getRecentInternal());

    // }, [publicStatus, dispatch]);

    const {resourceCategoryId} = useParams()

    const [resources, setResources ] = useState([])
    const [searchInput, setSearchInput] = useState("")
    const [value, setValue] = useState("")
    const [authorValue, setAuthorValue] = useState("")
    const [keywordValue, setKeywordValue] = useState("")
    const [nlnValue, setNlnValue] = useState("")
    const [loading, setLoading ] = useState(false)
    const [error, setError ] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")


    useEffect(() => {

        
        let mounted = true;
        const getResourceByCategory = async () => {
          try {
            const response = await fetch(
                
                ("https://nigeriana-api-staging.herokuapp.com/api/v1/library/public/resources/?resourceCategoryId=" + resourceCategoryId ),
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            const data = await response.json();
            setResources(data?.data?.results);
            setLoading(false);
          } catch (error) {
            setError(true);
            setErrorMessage(error?.message);
            setLoading(false);
          }
        };
        if (mounted) {
            getResourceByCategory();
            
        }
        return () => {
          mounted = false;
        }; 
    

      }, [searchInput]);

      const Decider = (title, author, keyword, nln) => {
        // if(title){
            // return title !== '' &&  item.resourceTitle.includes(title)
        // }
        // }else if(title || authour)
      }

      const filteredArray = value === '' && authorValue === '' && keywordValue === '' && nlnValue === '' ? resources : resources?.filter((item) => {

        const title = value === '' ? null : value.toLowerCase();
        const author = authorValue === '' ? null : authorValue.toLowerCase();
        const keyword = keywordValue === '' ? null : keywordValue.toLowerCase();
        const nln = nlnValue === '' ? null : nlnValue.toLowerCase();

        if(title === null || author === null || keyword === null || nln === null){
            
           return (item.resourceAuthor.toLowerCase().includes(author) || item.resourceTitle.toLowerCase().includes(title) || item.resourceNlnCode.toLowerCase().includes(nln) || item.resourceKeyword.toLowerCase().includes(keyword)
)            
        }

        return (
            
            item.resourceAuthor.toLowerCase().includes(author) && item.resourceTitle.toLowerCase().includes(title) && item.resourceNlnCode.toLowerCase().includes(nln) && item.resourceKeyword.toLowerCase().includes(keyword)
            
            )
    
    } )



      
  return (
    <Container>
        <NavBar />
        <InnerContainer>
            {/* <h2>Nigeriana Publications</h2> */}
            {/* <p>Below are Nigerian publications made in Nigeria </p> */}

            <NewsSearch>

                <div>
                    <form >
                        <h5>Search Publications</h5>
                        <InputContainer>
                            
                            <input 
                                type="search" 
                                placeholder='Title'
                                value={value}
                                onChange={(e) => setValue(e.target.value) }


                            />
                        </InputContainer>

                        <InputContainer>
                            
                            <input 
                                type="search" 
                                placeholder='Author' 
                                value={authorValue}
                                onChange={(e) => setAuthorValue(e.target.value)}
                            />
                        </InputContainer>

                        <InputContainer>
                            
                            <input 
                                type="search" 
                                placeholder='Keyword' 
                                value={keywordValue}
                                onChange={(e) => setKeywordValue(e.target.value)}
                                />
                        </InputContainer>
                        
                        <InputContainer>
                            
                            <input 
                                type="search" 
                                placeholder='NLN Code' 
                                value={nlnValue}
                                onChange={(e) => setNlnValue(e.target.value)}
                                />
                        </InputContainer>


                        

                        <ButtonContainer>
                            {/* <Button filled bgColor={'#2A870E'} noIcon text={'Search'} /> */}
                            {/* <Button filled bgColor={'#fa8072'} noIcon text={'Reset'} /> */}
                        </ButtonContainer>

                    </form>

                    <div>

                        <h5>Sort Search Result</h5>
                            <InputContainer>
                                <label htmlFor="date">Sort by year</label>
                                <DateInput>
                                    <input name='date' type="search" placeholder='From' />
                                    <input name='date' type="search" placeholder='To' />
                                </DateInput>
                            </InputContainer>

                            <InputContainer>
                                <label htmlFor="date">Sort Alphabetically</label>
                                <select name="" id="">
                                    <option value="">A-Z</option>
                                    <option value="">Z-A</option>
                                </select>
                            
                            </InputContainer>
                    </div>

                </div>

                

                <Publications>
                {filteredArray.length === 0 ? <div> No result matches the search parameters </div> :


                filteredArray?.map((resource) => {
                    
                    return(
                        <LinkToDetails key={resource?.resourceId} to={`/nigeriana/resource/${resource.resourceNlnCode} `} >
                            <CardsContainer >
                                <BoxContainer>
                                    <ImageContainer src={resource?.resourceImage} />
                                    <TextContainer>
                                        <h5>
                                        {resource?.resourceTitle}
                                        </h5>
                                        <small>by
                                         <span> {resource?.resourceAuthor} </span> 
                                        </small>
                                    </TextContainer>
                                </BoxContainer>
                            </CardsContainer>
                        </LinkToDetails>
                    )
                })
            }
                </Publications>
            </NewsSearch>
            <Pagination />
        </InnerContainer>
        

        <Footer />
        
    </Container>
  )
}

const Container = styled.section`
    width: 100%;
    max-width: 1250%;
    margin: 0 auto;

`
export const InnerContainer = styled.div`
    width: 80%;
    max-width: 1250px;
    display: flex;
    margin: 0 auto;
    padding-top: 30px;
    justify-content: center;
    flex-direction: column;

    &  select{
        background-color: inherit;
        border: 2px solid #D0D5DD;
        border-radius: 4px;
        height: 32px;
        padding: 0 10px;

        & > option{
            height: 30px;
        }
    }

    @media screen and (max-width: 600px){
        width: 90%;

    }
`

export const NewsSearch = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 70px;

    @media screen and (max-width: 600px){
        flex-direction: column;
        padding-top: 40px;
    }

    & > div{
        width: 30%;
        /* position: fixed; */

        @media screen and (max-width: 600px){
            width: 100%;
        }
    

    & form{
        /* flex: 1; */
        padding-bottom: 50px;
        /* width: 100%; */
        position: sticky;

        
        
    }

}
`

const LinkToDetails = styled(Link)`
    text-decoration: none;
    color: #000;
`

export const Publications = styled.section`
    /* flex: 2; */
    width: 65%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 20px;

    @media screen and (max-width: 600px){
        width: 100%;
        justify-content: center;
    }
`

export const DateInput = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 5px;
    width: inherit;
    justify-content: space-between;

    & input{
        width: 47%;
    }
`

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 20px;
    width: 80%;
    height: 44px;
    justify-content: space-between;

    @media screen and (max-width: 600px){
        width: 45%;
    }
`
const CardsContainer = styled.div`
    padding-bottom: 20px;
`


export {SingleCategory}